<template>
  <section id="hero" >
   <!--      :src="require('@/assets/compac/home-compac_reducida2.png')"-->
   <v-container fluid class="hero-section pa-0">
    <v-row class="hero-row ma-0" align="center" justify="center">
      <!-- Imagen de fondo solo visible en desktop -->
      <v-img
        :src="require('@/assets/compac/home-compac3.png')"
        class="hero-background d-none d-md-block"
        gradient="to right,rgba(255, 255, 255, 0.20),rgba(0,0,0,0.2)"
        
        style="background-repeat: no-repeat !important; 
         background-size: cover !important;
        background-position: center center !important;"
        
      />
      <!--rgba(0,0,0,0.1)"-->
      <!-- Contenido principal -->
      <v-col cols="12" md="6" class="content-column pa-8 pa-md-12">
        <!-- Logo -->
        <div class="text-center mb-6">
          <v-img
            :src="require('@/assets/compac/logo.png')"
            max-width="200"
            class="mx-auto logo-image"
            contain
            style="max-height: 170px !important;"
          />
        </div>

        <!-- Título principal -->
        <h1 class="display-1 font-weight-bold  text-center mb-7" style="color: #204165;">
          Consejo Mexicano de Patología Clínica y Medicina de Laboratorio, A.C.
        </h1>
       

        <v-row class="service-cards" justify="center">
             
          <v-col cols="12" md="12" sm="7" class="d-flex justify-center">
            <v-card class=""
                width="500"   
                hover
                >
              <v-img
                :src="require('@/assets/compac/solicta_aval_academico.jpg')"
                style="max-height: auto;"
                  />
                  <v-card-actions class="d-flex justify-center">
                    <v-btn
                    color="primary"
                    to="/educacion-continua"
                  >
                    Solicitar Aval
                  </v-btn>
                </v-card-actions>
            </v-card>
            
          </v-col>

        </v-row>
      </v-col>
     

      <!-- Imagen lateral solo en desktop -->
      <v-col cols="12" md="6" class="d-none d-md-flex align-center justify-center pa-0">
        
      </v-col>
    </v-row>
  </v-container>
    
   
  </section>
</template>
<script>
  export default {
    name: 'SectionHero',
    /*provide: {
      theme: { isDark: true },
    },*/
    metaInfo () {
      return {
        changed: meta => (this.title = meta.titleChunk.toUpperCase()),
      }
    },
    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'
        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },

  }
</script>

<style scoped>
.hero-section {
  min-height: 80vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}


.hero-row {
  position: relative;
  min-height: 80vh;
}

.hero-background {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  
}

.content-column {
  position: relative;
  z-index: 1;
}

.logo-image {
  animation: fadeInDown 1s ease-out;
}

.service-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.side-image {
  animation: fadeInRight 1s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Estilos para móviles */
@media (max-width: 959px) {
  .hero-section {
    min-height: auto;
  }
  
  .hero-row {
    min-height: auto;
  }
  
  .content-column {
    background: rgba(255, 255, 255, 0.95);
  }
}


</style>
